import React, { useEffect, useState } from "react";
import { gql, useMutation } from "@apollo/client";
import logo from "../../assets/logo.png";
import {
  Overlay,
  PopupBox,
  CloseBtn,
  Badge,
  Title,
  Text,
  Form,
  Input,
  Button,
  Success,
  Error,
  Logo,
} from "./CouponPopupStyles";

const REQUEST_MARKETING_COUPON = gql`
  mutation RequestMarketingCoupon($email: String!) {
    requestMarketingCoupon(email: $email) {
      success
      message
    }
  }
`;

export default function CouponPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const [requestCoupon, { loading }] = useMutation(REQUEST_MARKETING_COUPON);

  useEffect(() => {
    const alreadyClosed = localStorage.getItem("coupon_popup_closed");
    const alreadySent = localStorage.getItem("coupon_popup_sent");

    if (!alreadyClosed && !alreadySent) {
      const timer = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    localStorage.setItem("coupon_popup_closed", "true");
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setSuccess(false);
      setMessage("Introdu adresa de e-mail.");
      return;
    }

    if (!emailRegex.test(email.trim())) {
      setSuccess(false);
      setMessage("Introdu o adresă de e-mail validă.");
      return;
    }

    try {
      const { data } = await requestCoupon({
        variables: {
          email: email.trim().toLowerCase(),
        },
      });

      const result = data?.requestMarketingCoupon;

      setSuccess(!!result?.success);
      setMessage(result?.message || "");

      if (result?.success) {
        localStorage.setItem("coupon_popup_sent", "true");
      }
    } catch (err) {
      setSuccess(false);
      setMessage(err.message || "Nu am putut trimite cuponul.");
    }
  };

  if (!open) return null;

  return (
    <Overlay>
      <PopupBox>
        <CloseBtn type="button" onClick={closePopup}>
          ×
        </CloseBtn>

        <Logo src={logo} alt="Ahava Cakes" />
        <Badge>🎁 Cadou dulce</Badge>

        <Title>
          Primești <span>10%</span> reducere
        </Title>
        <Text>
          Lasă adresa de e-mail și, dacă nu ai mai primit deja un cupon, îți
          trimitem un cod unic de 10% reducere pentru următoarea comandă.
        </Text>

        <Form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="email@exemplu.ro"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button type="submit" disabled={loading}>
            {loading ? "Se trimite..." : "Trimite-mi cuponul"}
          </Button>
        </Form>

        {message ? (
          success ? (
            <Success>{message}</Success>
          ) : (
            <Error>{message}</Error>
          )
        ) : null}
      </PopupBox>
    </Overlay>
  );
}
